import { useEffect, useRef } from 'react';
import { IRoute } from '../../routes/routes';
import { INavigationItem } from "../../services/navigation-data-service/Models";
import NavigationGroupTree from '../navigation/NavigationGroupTree';
import BreadCrumbMenu from './BreadCrumbMenu';
import useAutoScroll from "../../hooks/use-auto-scroll/useAutoScroll";

export type BreadCrumbGroupMenuProps = {
    open: boolean;
    anchorEl?: HTMLElement | null;
    placement?: "bottom" | "right";
    offset?: [number, number];
    item: INavigationItem;
    route: IRoute;
    offline: boolean;
    onClick?: (item: INavigationItem, route: IRoute, shiftKey: boolean, ctrlKey: boolean) => void;
    onClose?: () => void;
};

export default function BreadCrumbGroupMenu({
    open,
    anchorEl,
    placement,
    offset,
    route,
    onClick,
    onClose,
}: BreadCrumbGroupMenuProps) {

    const menuRef = useRef<HTMLDivElement>(null);

    useAutoScroll(open, menuRef);

    return (
        <BreadCrumbMenu
            anchorEl={anchorEl}
            placement={placement}
            offset={offset}
            open={open}
            onClose={() => onClose?.()}
            ref={menuRef}
        >
            <NavigationGroupTree
                route={route}
                onClick={onClick}
            />
        </BreadCrumbMenu>
    );
}